import { useContext } from 'react';

import { AbilityContext } from '@cast/shared-ability-data-access';

/**
 * Gate for org-scoped reporting-monetization APIs.
 * Uses AbilityContext.can (no clusterId) so cluster-scoped bindings do not match.
 */
export const useCanFetchReportingMonetization = (): {
  canFetch: boolean;
  isAbilityLoading: boolean;
} => {
  const ability = useContext(AbilityContext);
  const isAbilityLoading = ability.isLoading;

  return {
    isAbilityLoading: Boolean(isAbilityLoading),
    canFetch:
      !isAbilityLoading &&
      // Optional: InitApp can render outside AbilityProvider.
      Boolean(ability.can?.('view', 'OrganizationCostMonitoring')),
  };
};
